module.exports = __webpack_public_path__ + "static/img/cont60 (1).78e7a13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont60 (1).jpg
// module id = Cvdi
// module chunks = 0